var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.router)?_c('router-link',{staticClass:"link",attrs:{"to":_vm.href}},[_vm._t("default")],2):_c('a',{staticClass:"link",attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }